import styled from "styled-components";
import { colors, breakpoints } from "definitions";

/* ---------------------------------------------------------------------------
   Filas de selección (temáticas y premios)
   ---------------------------------------------------------------------------
   Las tarjetas de 270 × 360 recortaban la descripción a 150px de alto con una
   barra de scroll adentro, y el rótulo "PREMIO" iba escrito en vertical. Como
   fila entra la descripción completa, el rótulo se lee de corrido y las
   acciones quedan siempre en el mismo lugar.
--------------------------------------------------------------------------- */

export const OptionList = styled.ul`
  display: grid;
  gap: 1.2rem;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const OptionRow = styled.li`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.8rem 2.4rem;
  align-items: center;
  padding: 1.8rem 2rem;
  border: 1px solid #dde3ee;
  border-radius: 12px;
  background: ${colors.background.white};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  :hover {
    border-color: #9cc4f5;
    box-shadow: 0 6px 18px rgba(8, 37, 90, 0.08);
  }

  ${breakpoints.tablet} {
    grid-template-columns: minmax(0, 1fr);
    padding: 1.6rem;
  }
`;

export const OptionText = styled.div`
  display: grid;
  gap: 0.6rem;
  min-width: 0;
`;

export const OptionKind = styled.span`
  justify-self: start;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  background: #e8f1fd;
  color: ${colors.fonts.yellowGreen};
  font-family: Lato;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  line-height: 1.5rem;
  text-transform: uppercase;
`;

export const OptionTitle = styled.h3`
  margin: 0;
  font-family: Lato;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 2.2rem;
  color: ${colors.icons.darkBlue};
`;

export const OptionDescription = styled.p`
  margin: 0;
  max-width: 70ch;
  font-family: Lato;
  font-size: 1.35rem;
  font-weight: 400;
  line-height: 2rem;
  color: #5b6470;
`;

export const OptionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  ${breakpoints.tablet} {
    flex-direction: column-reverse;
    align-items: stretch;
    margin-top: 0.6rem;

    > * {
      width: 100%;
    }
  }
`;

// El "volver" es navegación, no una acción del paso: va aparte de la lista.
export const OptionFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1.6rem;
`;
